import {
  ApolloClient,
  ApolloLink,
  concat,
  HttpLink,
  InMemoryCache,
} from "@noom/hive-core";
import { appConfig } from "src/config";
import { getAccessToken } from "src/utils/authCookieParser";

function getAuthorizationHeader() {
  const accessToken = getAccessToken();
  return accessToken ? `Bearer ${accessToken}` : "";
}

const httpLink = new HttpLink({
  uri: appConfig.GRAPHQL_URL,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      Authorization: getAuthorizationHeader(),
    },
  }));

  return forward(operation);
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
});
